import { managerKpis, conversions, formatMoney, type ManagerKpiItem, type ConversionItem } from "@/mocks/managerWorkspace";

export default function ManagerKpiWidget() {
  const totalPlan = 100;
  const kpiWithPercents = managerKpis.map((k: ManagerKpiItem) => {
    const percent = k.plan === 0 ? (k.fact === 0 ? 100 : -1) : Math.round((k.fact / k.plan) * 100);
    const isMoney = k.unit === "₽";
    return { ...k, percent, isMoney };
  });

  return (
    <div className="bg-white rounded-lg border border-[#D5CA8A] overflow-hidden">
      <div className="flex items-center justify-between px-3 py-2 bg-[#FEF3C7] border-b border-[#D5CA8A]">
        <div className="flex items-center gap-1.5">
          <i className="ri-bar-chart-2-line text-[12px] text-[#2D2D2D]"></i>
          <span className="text-[11px] font-semibold text-[#2D2D2D]">KPI менеджера: Иванов И.И. | Май 2026</span>
        </div>
        <div className="flex items-center gap-3">
          <span className="text-[10px] text-[#666666]">
            План: <span className="font-semibold text-[#2D2D2D]">{totalPlan}%</span>
          </span>
          <span className="text-[10px] text-[#666666]">
            Факт: <span className="font-semibold text-[#2D6A4F]">78%</span>
          </span>
        </div>
      </div>

      <div className="p-3">
        {/* Conversions row */}
        <div className="flex items-center gap-4 mb-3 pb-3 border-b border-[#D5CA8A]/40">
          <span className="text-[10px] font-semibold text-[#666666] whitespace-nowrap">Конверсии:</span>
          {conversions.map((c: ConversionItem, i: number) => (
            <div key={i} className="flex items-center gap-2">
              <div className="flex items-center gap-1 text-[10px]">
                <span className="text-[#666666]">{c.from}</span>
                <i className="ri-arrow-right-line text-[8px] text-[#666666]"></i>
                <span className="text-[#666666]">{c.to}</span>
              </div>
              <span className="text-[12px] font-bold text-[#2D6A4F]">{c.rate}%</span>
              <i className={`${c.trend === "up" ? "ri-arrow-up-line text-[#2D6A4F]" : "ri-arrow-down-line text-[#DC2626]"} text-[10px]`}></i>
            </div>
          ))}
        </div>

        {/* KPI Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-2.5">
          {kpiWithPercents.map((k, i) => (
            <div key={i} className="flex items-start gap-2 p-2 rounded border border-[#D5CA8A]/40 hover:bg-[#FDF2B5]/10 transition-colors">
              <div className={`w-7 h-7 rounded flex items-center justify-center flex-shrink-0 ${k.iconBg}`}>
                <i className={`${k.icon} text-[13px] ${k.color}`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-[9px] text-[#666666] leading-tight truncate">{k.label}</p>
                <div className="flex items-baseline gap-1 mt-0.5">
                  <span className="text-[13px] font-bold text-[#2D2D2D] leading-tight">
                    {k.isMoney ? formatMoney(k.fact) : k.fact}
                  </span>
                  <span className="text-[9px] text-[#666666]">
                    / {k.isMoney ? formatMoney(k.plan) : k.plan}
                  </span>
                </div>
                {/* Progress bar */}
                <div className="mt-1 flex items-center gap-1.5">
                  <div className="flex-1 h-1.5 bg-[#FDF2B5]/60 rounded-full overflow-hidden">
                    <div
                      className={`h-full rounded-full transition-all ${k.percent >= 100 ? "bg-[#2D6A4F]" : k.percent >= 70 ? "bg-[#D97706]" : k.percent >= 0 ? "bg-[#DC2626]" : "bg-[#DC2626]/40"}`}
                      style={{ width: `${Math.min(Math.max(k.percent, 0), 100)}%` }}
                    ></div>
                  </div>
                  <span className={`text-[8px] font-medium flex-shrink-0 ${k.percent >= 100 ? "text-[#2D6A4F]" : k.percent >= 70 ? "text-[#D97706]" : "text-[#DC2626]"}`}>
                    {k.percent < 0 ? "—" : `${k.percent}%`}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}